import React from 'react'
import {Route, Switch} from 'react-router'
import VisibleProfile from './containers/VisibleProfile'
import VisibleEditProfile from './edit-profile/containers/VisibleEditProfile'

class UserSwitch extends React.PureComponent {
  render() {
    return (
      <Switch>
        <Route path="/user/:userId/edit"
          component={VisibleEditProfile} />
        <Route path="/user/:userId"
          component={VisibleProfile} />
      </Switch>
    )
  }
}

export default [
  <Route exact key='user/default' path='/user/:userId' component={UserSwitch} />,
  <Route exact key='user/default' path='/user/:userId/problems' component={UserSwitch} />,
  <Route exact key='user/default' path='/user/:userId/edit' component={UserSwitch} />,
  <Route exact key='user/default' path='/user/:userId/edit/account' component={UserSwitch} />,
  <Route exact key='user/default' path='/user/:userId/edit/password' component={UserSwitch} />,
  <Route exact key='user/default' path="/user/:userId/edit/notifications" component={UserSwitch} />,
]



// WEBPACK FOOTER //
// ./src/domains/user/index.js